import { CustomInput } from '@paytrace/pt-skel/Component'
import React from 'react'

interface RadioOption<T = string> {
  label: string
  value: T
}

export interface InputRadioProps<T = string> {
  name: string
  label: string
  items: RadioOption<T>[]
  value?: T
  onChange?: (value: T) => void
  className?: string
}

export function InputRadio<T extends string> ({
  name,
  label,
  items,
  value,
  onChange,
  className,
  ...passProps
}: InputRadioProps<T>) {
  return (
    <CustomInput className={className || 'radio-label'}>
      <label>{label}</label>
      {items.map((item) => (
        <label key={`${name}-${item.value}`}>
          <input
            type='radio'
            name={name}
            value={item.value}
            checked={value === item.value}
            onChange={() => onChange?.(item.value)}
            {...passProps}
          />
          {item.label}
        </label>
      ))}
    </CustomInput>
  )
}
